import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JiraIssue } from '../models/jira-issue-form';

@Injectable({
  providedIn: 'root'
})
export class JiraService {

  public jiraUrl = `${environment.urlBase}/jira/create-ticket`;

  constructor(private http: HttpClient) { }

  /**
   * Creates a user
   * @param {JiraIssue} jiraIssue
   * @returns {Observable<JiraIssue>}
   */
  createIssue(jiraIssue: JiraIssue): Observable<JiraIssue> {
    return this.http.post<JiraIssue>(this.jiraUrl, jiraIssue);
  }
}
